import { useTranslation } from 'react-i18next'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { ProcessorDetails } from '@/lib/api/processors'

interface NMIDescriptorCardProps {
    processor: ProcessorDetails
}

const getDescriptor = (options: Record<string, unknown> | null) => {
    return options?.descriptor as { descriptor?: string; mcc?: string; merchantId?: string } | undefined
}

export const NMIDescriptorCard = ({ processor }: NMIDescriptorCardProps) => {
    const { t } = useTranslation('processors')
    const descriptor = getDescriptor(processor.options)

    return (
        <Card className="mb-6">
            <CardHeader>
                <CardTitle>{t('descriptorSettings')}</CardTitle>
            </CardHeader>
            <CardContent>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <p className="text-sm text-muted-foreground">{t('statementDescriptor')}</p>
                        <p className="font-semibold">{descriptor?.descriptor || t('notConfigured')}</p>
                    </div>

                    <div>
                        <p className="text-sm text-muted-foreground">{t('merchantCategoryCode')}</p>
                        <p className="font-semibold">{descriptor?.mcc || t('notConfigured')}</p>
                    </div>

                    <div>
                        <p className="text-sm text-muted-foreground">{t('merchantId')}</p>
                        <p className="font-semibold">{descriptor?.merchantId || t('notConfigured')}</p>
                    </div>
                </div>
            </CardContent>
        </Card>
    )
}

